import { render } from "./Spinner.vue?vue&type=template&id=97435066"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=97435066&lang=css"

import exportComponent from "C:\\Projects\\photar-beta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__